import { ExerciseDTO } from '../generated';

export interface FilterProps {
  name?: string | undefined;
  public?: boolean;
  bodyZoneId?: string;
  categoryIds?: Array<string>;
  equipmentIds?: Array<string>;
}

export const filter = (exercises: Array<ExerciseDTO>, props: FilterProps) => {
  const { name } = props;
  return exercises
    .filter((e) => !props.equipmentIds?.length || props.equipmentIds.every((cid) => e.equipment.some((e) => e.equipmentId === cid)))
    .filter((e) => !props.categoryIds?.length || props.categoryIds.every((cid) => e.categoryIds?.includes(cid)))
    .filter((e) => (!props.public && !e.publiclyVisible) || (props.public && e.publiclyVisible) || props.public === undefined)
    .filter((e) => (name !== undefined ? e.name.toLowerCase().includes(name.toLowerCase()) || e.synonyms?.some((s) => s.toUpperCase().indexOf(name.toUpperCase()) > -1) : true))
    .filter((e) => (props.bodyZoneId ? e.mainBodyZoneId === props.bodyZoneId : true));
};
